module.exports = {
    // dataUrl : 'http://itechdemo.in/secapistaff/api/',
    dataUrl: process.env.REACT_APP_API_BASE_URL,
    // dataUrl: "https://dev-nxtpick.itechlabs.net/api/v1/nxtpick/",
    version: '1.0.0',
    appColor: 'background: #262834 0% 0% no-repeat padding-box',
    // reactUrl : process.env.REACT_APP_BASE_URL,
    reactUrl: "",
    emptyUser: "https://emitherapy.co.za/wp-content/uploads/2020/08/person-icon.png"
}